<button
  (click)="select()"
  [ngClass]="{
    checked: model === value,
    'not-checked': model !== value,
    disabled: isDisabled,
    big: size === 'big',
    normal: size === 'normal',
  }"
  [ngStyle]="{ textAlign: align }"
>
  @if (model === value) {
    <div class="circle"></div>
  } @else {
    <div class="circle"></div>
  }

  <ng-content></ng-content>
</button>
